import React, { useState, useEffect } from 'react'
import './Layout.css'
import { NavLink } from 'react-router-dom'
import MyTooltip from '../../utilities/tooltip/MyTooltip'

//svg
import SvgDashboard from '../../svgIcons/SvgDashboard'
import SvgDocument from '../../svgIcons/SvgDocument'
import SvgContact from '../../svgIcons/SvgContact'

function SideBar() {
  const [direction, setDirection] = useState('right')
  useEffect(() => {
    if (window.innerWidth <= 769) {
      setDirection('top')
    } else {
      setDirection('right')
    }
  }, [window.innerWidth])
  return (
    <nav className='navbar'>
      <ul className='navbar-nav'>
        <li className='nav-item'>
          <MyTooltip tips='Dashboard' direction={direction}>
            <NavLink to='/dashboard' className='nav-link'>
              <SvgDashboard />
            </NavLink>
          </MyTooltip>
        </li>

        <li className='nav-item'>
          <MyTooltip tips='Documents' direction={direction}>
            <NavLink to='/viewDocumentTable' className='nav-link'>
              <SvgDocument />
            </NavLink>
          </MyTooltip>
        </li>

        <li className='nav-item'>
          <MyTooltip tips='Profiles' direction={direction}>
            <NavLink to='/viewProfileTable' className='nav-link'>
              <SvgContact />
            </NavLink>
          </MyTooltip>
        </li>
      </ul>
    </nav>
  )
}

export default SideBar
